
import { Injectable } from '@angular/core';
import {
    CanActivate,
    Router,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    CanActivateChild,
    CanLoad,
    Route
} from '@angular/router';
import { AuthHelper } from './common/auth.helper';
import { PermissionService } from './shared/services/permission.service';
import { BaseService } from './shared/services/base.service';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {
    public landingRedirect: string = '/landing';
    public waitingRoomRedirect: string = '/consultation/waiting-room';
    constructor(private router: Router,
                private permissionService: PermissionService,
                private baseService: BaseService) {
    }

    // Not using but worth knowing about
    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (AuthHelper.isLoggedIn(state.url)) {
          if (AuthHelper.isSelectedCentre()){
            return true;
          } else {
            this.router.navigate(['/select-centre']);
            return false;
          }
        }
       // this.router.navigate([this.landingRedirect]);
       console.log('canActivate and call logout function');
        this.baseService.logout();
        return false;
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (AuthHelper.isLoggedIn(state.url) && AuthHelper.isSelectedCentre()) {
            // check if route has params
            let url = state.url.split('?')[0];
            if (route.params) {
                if (route.params.hasOwnProperty('id')) {
                    url = url.replace(route.params['id'], ':id');
                }
                if (route.params.hasOwnProperty('patientId')) {
                    url = url.replace(route.params['patientId'], ':patientId');
                }
                if (route.params.hasOwnProperty('isFromHistory')) {
                    url = url.replace(route.params['isFromHistory'], ':isFromHistory');
                }
                if (route.params.hasOwnProperty('clinicId')) {
                    url = url.replace(route.params['clinicId'], ':clinicId');
                }
            }
            // check permission on page
            if (this.permissionService.hasPermissionOnUrl(url)) {
                return true;
            } else if (this.permissionService.hasPermissionOnUrl(this.waitingRoomRedirect)){
                // if user do not has permission on this page then navigates to Waiting Room page
                this.router.navigate([this.waitingRoomRedirect]);
                return false;
            }
        }
        //this.router.navigate([this.landingRedirect]);
        console.log('canActivateChild and call logout function');
        this.baseService.logout();
        return false;
    }

    canLoad(route: Route): boolean {
        const url = `/${route.path}`;
        if (AuthHelper.isLoggedIn(url) && AuthHelper.isSelectedCentre()) {
            return true;
        }
        //this.router.navigate([this.landingRedirect]);
        console.log('canLoad and call logout function');
        this.baseService.logout();
        return false;
    }

}

export const authProviders = [AuthGuard, AuthHelper];



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/auth.guard.ts